'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetUser } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { levelForDays } from '@/lib/streaks';
import { TierEmblem } from './tier-emblem';
interface ProfileStreakStatProps {
  userId: string;
  walletPubkeys?: readonly string[] | undefined;
  /** Render a 0-day streak instead of hiding (partner creator profiles). */
  showZero?: boolean;
}

/** Read-only streak stat (emblem + day count) for another user's profile. Hidden at 0. */
export function ProfileStreakStat(t0) {
  const $ = _c(21);
  const {
    userId,
    walletPubkeys,
    showZero: t1
  } = t0;
  const showZero = t1 === undefined ? false : t1;
  const t = useTranslations("streaks");
  let t2;
  if ($[0] !== walletPubkeys) {
    t2 = walletPubkeys ?? [];
    $[0] = walletPubkeys;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["currentStreak"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== userId) {
    t4 = {
      identifier: userId,
      walletPubkeys: t2,
      fields: t3
    };
    $[3] = t2;
    $[4] = userId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data
  } = useGetUser(t4);
  const currentStreak = data?.currentStreak ?? 0;
  let t5;
  if ($[6] !== currentStreak) {
    t5 = levelForDays(currentStreak);
    $[6] = currentStreak;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const level = t5;
  if (currentStreak === 0 && !showZero) {
    return null;
  }
  let t6;
  if ($[8] !== level) {
    t6 = <TierEmblem level={level} size={16} />;
    $[8] = level;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== currentStreak) {
    t7 = <span className="font-medium tabular-nums text-foreground-primary">{currentStreak}</span>;
    $[10] = currentStreak;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== currentStreak || $[13] !== t) {
    t8 = t("day_streak_label", {
      count: currentStreak
    });
    $[12] = currentStreak;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <span className="font-normal text-foreground-tertiary">{t8}</span>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
    t10 = <span className="inline-flex items-center gap-1 whitespace-nowrap text-body">{t6}{t7}{t9}</span>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}